const common = {
  "nav.categories": "Kategorien",
  "nav.guides": "Ratgeber",
  "nav.about": "Über uns",
  "nav.faq": "FAQ",
  "nav.cta": "Jetzt kaufen",
  "nav.home": "Startseite",
  "nav.shoppingGuide": "Einkaufsführer",

  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.es": "Español",
  "lang.pt": "Português",

  "hero.badge": "Basetao Spreadsheet Ressourcen-Hub",
  "hero.title": "Basetao Spreadsheet: Produkte, Verkäufer & Kaufratgeber",
  "hero.subtitle":
    "Ein sauberer, unabhängiger Ressourcen-Hub, der dir hilft, Basetao-Produktkategorien, kuratierte Links und praktische Kauftipps zu entdecken — alles an einem Ort.",
  "hero.cta1": "Basetao Spreadsheet",
  "hero.cta2": "Jetzt kaufen",
  "hero.dropdownLabel": "Zu einer Kategorie springen",

  "cat.dropdownPlaceholder": "Kategorie wählen…",

  "catSection.eyebrow": "Im Spreadsheet stöbern",
  "catSection.title": "Kategorien entdecken",
  "catSection.subtitle":
    "Stöbere durch die beliebtesten Produktkategorien im Basetao Spreadsheet und springe direkt zu den Artikeln, die du suchst.",
  "catSection.shopNow": "Jetzt shoppen",

  "cat.shoes": "Schuhe",
  "cat.hoodies": "Hoodies / Sweater",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jacken",
  "cat.pants": "Hosen / Shorts",
  "cat.headwear": "Kopfbedeckung",
  "cat.sets": "Sets",
  "cat.underwear": "Unterwäsche",
  "cat.jersey": "Trikots",
  "cat.accessories": "Accessoires",
  "cat.bags": "Taschen",
  "cat.belts": "Gürtel",
  "cat.perfumes": "Parfums",
  "cat.other": "Sonstiges",

  "guides.eyebrow": "Ratgeber & Ressourcen",
  "guides.title": "Beliebte Ratgeber",
  "guides.subtitle":
    "Originelle, praktische Artikel, die erklären, wie du das Basetao Spreadsheet nutzt und sicher einkaufst.",
  "guides.readMore": "Ratgeber lesen",
  "guides.card.badge": "Einsteiger-Ratgeber",
  "guides.card.title": "Basetao Spreadsheet Ratgeber: Was es ist & wie es funktioniert",
  "guides.card.excerpt":
    "Eine klare, einsteigerfreundliche Einführung, was ein Basetao Spreadsheet ist, wie man es liest und wie man damit Produkte, Verkäufer und bessere Preise findet.",

  "about.eyebrow": "Was ist das?",
  "about.title": "Was ist ein Basetao Spreadsheet?",
  "about.p1":
    "Ein Basetao Spreadsheet ist eine geteilte, organisierte Liste aus Produkten, Links, Verkäufern und Notizen, die von Käufern erstellt wird, die Basetao nutzen, um auf chinesischen Marktplätzen zu bestellen und international zu versenden. Statt bei null anzufangen, beginnst du mit einer kuratierten Auswahl an Artikeln, die andere Käufer bereits gefunden und geprüft haben.",
  "about.p2":
    "Da sich eine Tabelle leicht filtern, sortieren und teilen lässt, ist sie eine praktische Möglichkeit, Produkte über Kategorien wie Schuhe, Hoodies, T-Shirts, Jacken, Taschen und Accessoires hinweg zu vergleichen und den Überblick über Verkäufer und Qualitätskontroll-Notizen zu behalten.",
  "about.point1.title": "Kuratierte Produkte",
  "about.point1.text":
    "Links zu bestimmten Artikeln sind nach Kategorie sortiert, sodass du weniger suchst und mehr vergleichst.",
  "about.point2.title": "Verkäufer- & QC-Notizen",
  "about.point2.text":
    "Nützliche Hinweise zu Verkäufern und Qualitätskontrollen helfen dir, vor der Bestellung verlässliche Optionen zu erkennen.",
  "about.point3.title": "Teilbar & aktuell",
  "about.point3.text":
    "Tabellen lassen sich leicht teilen und aktualisieren, damit die Liste aktuell bleibt, wenn neue Produkte und Notizen hinzukommen.",

  "features.eyebrow": "Warum nutzen",
  "features.title": "Warum ein Basetao Spreadsheet nutzen?",
  "features.subtitle":
    "Ein paar Gründe, warum Käufer beim Bestellen über Basetao auf eine organisierte Tabelle setzen.",
  "features.f1.title": "Zeit sparen",
  "features.f1.text": "Starte mit einer fertigen Liste, statt Dutzende Seiten einzeln durchzusehen.",
  "features.f2.title": "Leicht vergleichen",
  "features.f2.text": "Sieh Produkte nebeneinander nach Kategorien, Verkäufern und Preisen.",
  "features.f3.title": "Organisiert bleiben",
  "features.f3.text": "Halte deine Favoriten, Notizen und QC-Details an einem übersichtlichen Ort.",
  "features.f4.title": "Mit Kontext kaufen",
  "features.f4.text":
    "Kombiniere Produktlinks mit Verkäufer- und QC-Notizen für sicherere Entscheidungen.",

  "faq.eyebrow": "FAQ",
  "faq.title": "Häufig gestellte Fragen",
  "faq.q1": "Was ist ein Basetao Spreadsheet?",
  "faq.a1":
    "Eine geteilte, organisierte Liste aus Produkten, Links, Verkäufern und Notizen, mit der Käufer über Basetao bestellte Artikel finden und vergleichen.",
  "faq.q2": "Ist diese Website mit Basetao verbunden?",
  "faq.a2":
    "Nein. BasetaoSheet.casa ist eine unabhängige Informationsquelle und nicht zwingend mit Basetao verbunden, sofern nicht ausdrücklich angegeben.",
  "faq.q3": "Wie nutze ich die Kategorien auf dieser Seite?",
  "faq.a3":
    "Wähle eine Kategorie aus dem Dropdown oder dem Raster und du gelangst zur passenden Produktseite auf unserer Hauptseite.",
  "faq.q4": "Brauche ich ein Konto zum Stöbern?",
  "faq.a4": "Nein, du kannst Kategorien und Ratgeber frei erkunden, ohne dich anzumelden.",
  "faq.q5": "Sind Preise und Verkäufer garantiert?",
  "faq.a5":
    "Preise, Verfügbarkeit und Verkäuferdaten können sich ändern. Prüfe vor der Bestellung immer die Produktseite auf der Hauptseite.",

  "cta.title": "Bereit, den ganzen Katalog zu entdecken?",
  "cta.subtitle": "Stöbere durch alle Kategorien auf der Hauptseite und finde die Artikel, die du suchst.",
  "cta.button": "Jetzt kaufen",

  "footer.tagline":
    "Basetao Sheet ist ein unabhängiger Ressourcen-Hub für das Basetao Spreadsheet, der Käufern hilft, Produkte, Kategorien und Ratgeber zu entdecken.",
  "footer.disclaimer": "Unabhängige Informationsquelle. Nicht zwingend mit Basetao verbunden.",
  "footer.explore": "Entdecken",
  "footer.resources": "Ressourcen",
  "footer.legal": "Rechtliches",
  "footer.guide": "Spreadsheet-Ratgeber",
  "footer.home": "Startseite",
  "footer.categories": "Kategorien",
  "footer.about": "Über uns",
  "footer.faq": "FAQ",
  "footer.rights": "Alle Rechte vorbehalten.",

  "home.breadcrumb": "Startseite",
  "article.notFound": "Artikel nicht gefunden",
  "article.faqHeading": "Häufig gestellte Fragen",
  "article.conclusionHeading": "Fazit",

  "notFound.title": "Seite nicht gefunden",
  "notFound.subtitle": "Die gesuchte Seite existiert nicht oder wurde möglicherweise verschoben.",
};

export default common;